/**
 * Search Page JavaScript
 * Uses the Shopify App Proxy product search API and renders results client-side.
 */

$(function () {
  "use strict";

  const API_PATH = "/apps/ping/products/search";
  const CONTENT_API_PATH = "/apps/ping/articles/search";
  const RANGE_MIN = 0;
  const RANGE_MAX = 4000;
  const RANGE_GAP = 100;
  const PAGE_SIZE = 24;
  const ALLOWED_SORT_ORDERS = ["popular", "new", "price_asc", "price_desc"];
  let currentRangeMax = RANGE_MAX;
  let hasUserAdjustedPriceRange = false;

  function formatPrice(value) {
    return Number(value || 0).toLocaleString("ja-JP") + "\u5186";
  }

  function escapeHtml(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/\"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function getSearchTranslation(key, fallback) {
    if (window.searchTranslations && window.searchTranslations[key]) {
      return String(window.searchTranslations[key]);
    }

    return String(fallback || "");
  }

  function getUrlParams() {
    return new URLSearchParams(window.location.search);
  }

  function isProductSearchMode() {
    const params = getUrlParams();
    const type = (params.get("type") || "product").trim().toLowerCase();
    return type === "" || type === "product";
  }

  function getSearchSection() {
    return (getUrlParams().get("section") || "").trim().toLowerCase();
  }

  function isContentSearchType() {
    return (getUrlParams().get("type") || "").trim().toLowerCase().indexOf("article") !== -1;
  }

  function getSearchMode() {
    const section = getSearchSection();
    if (isContentSearchType() && section === "") return "combined";
    if (isContentSearchType() && section === "article") return "article";
    if (isContentSearchType() && section === "product") return "product";
    const type = (getUrlParams().get("type") || "product").trim().toLowerCase();
    if (type !== "product") return "default";
    return "product";
  }

  function isArticleOriginMode() {
    return isContentSearchType();
  }

  function normalizeArticlePaginationLinks() {
    if (!isContentSearchType()) return;

    $("[data-search-default-mode] .pagination a[href]").each(function () {
      var href = $(this).attr("href");
      if (!href) return;

      var url = new URL(href, window.location.origin);
      url.searchParams.set("type", "article");
      url.searchParams.set("section", "article");

      $(this).attr("href", url.pathname + url.search + url.hash);
    });
  }

  // ============================================================
  // Content Search API helpers
  // ============================================================

  function getContentPage() {
    var p = parseInt(getUrlParams().get("content_page"), 10);
    return Number.isFinite(p) && p > 0 ? p : 1;
  }

  function buildContentApiUrl(page) {
    var url = new URL(CONTENT_API_PATH, window.location.origin);
    var q = getSearchQuery();
    if (q) url.searchParams.set("key", q);
    url.searchParams.set("page_size", "12");
    url.searchParams.set("current_page", String(page || 1));
    return url.toString();
  }

  function buildContentPageUrl(page) {
    var base = new URL(window.location.href);
    if (page > 1) {
      base.searchParams.set("content_page", String(page));
    } else {
      base.searchParams.delete("content_page");
    }
    return base.pathname + base.search + base.hash;
  }

  function formatContentDate(isoDate) {
    if (!isoDate) return "";
    var d = new Date(isoDate);
    if (isNaN(d.getTime())) return "";
    var y = d.getFullYear();
    var m = String(d.getMonth() + 1).padStart(2, "0");
    var day = String(d.getDate()).padStart(2, "0");
    return y + "." + m + "." + day;
  }

  function resolveBlogTagBadge(tags, blogHandle) {
    if (blogHandle === "giftpresent") return "ギフトの教科書";
    if (blogHandle === "store") return "店舗";
    if (blogHandle === "news") {
      var labels = window.blogTagLabels || {};
      for (var i = 0; i < tags.length; i++) {
        var t = tags[i];
        if (t.toLowerCase() === "ec") continue;
        var handle = t.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
        return labels[handle] || t;
      }
    }
    return "ブログ";
  }

  function renderContentCard(item) {
    var url = escapeHtml(item.url || "#");
    var title = escapeHtml((item.title || "").substring(0, 50));
    var dateStr = formatContentDate(item.published_at);
    var imgSrc = item.image
      ? escapeHtml(item.image)
      : item.type === "page"
        ? escapeHtml(window.defaultOgpImageUrl || "")
        : escapeHtml(window.defaultArticleImageUrl || "");

    if (item.type === "page") {
      return (
        '<li class="c-grid__item">' +
        '<a class="c-news-card" href="' + url + '">' +
        '<div class="c-news-card__img">' +
        '<img src="' + imgSrc + '" alt="' + title + '" loading="lazy">' +
        "</div>" +
        '<div class="c-news-card__body">' +
        '<h3 class="c-news-card__title">' +
        '<a href="' + url + '" class="full-unstyled-link">' + title + "</a>" +
        "</h3>" +
        '<div class="c-news-card__tags"><span class="c-tag">コンテンツ</span></div>' +
        "</div>" +
        "</a>" +
        "</li>"
      );
    }

    var badge = resolveBlogTagBadge(item.tags || [], item.blog_handle || "");
    return (
      '<li class="c-grid__item">' +
      '<a class="c-news-card" href="' + url + '">' +
      '<div class="c-news-card__img">' +
      '<img src="' + imgSrc + '" alt="' + title + '" loading="lazy">' +
      "</div>" +
      '<div class="c-news-card__body">' +
      '<h3 class="c-news-card__title">' +
      '<a href="' + url + '" class="full-unstyled-link">' + title + "</a>" +
      "</h3>" +
      (dateStr ? '<time class="c-news-card__date">' + dateStr + "</time>" : "") +
      '<div class="c-news-card__tags"><span class="c-tag">' + escapeHtml(badge) + "</span></div>" +
      "</div>" +
      "</a>" +
      "</li>"
    );
  }

  function renderContentPagination(data) {
    var totalPages = parseInt(data.total_page, 10) || 0;
    var currentPage = parseInt(data.current_page, 10) || 1;
    if (totalPages <= 1) return "";

    function buildPageItem(page) {
      if (page === "...") {
        return '<li class="pagination__item pagination__item--dots"><span class="pagination__link">...</span></li>';
      }
      if (page === currentPage) {
        return (
          '<li class="pagination__item pagination__item--number">' +
          '<a class="pagination__link is-active" aria-current="page">' + page + "</a>" +
          "</li>"
        );
      }
      return (
        '<li class="pagination__item pagination__item--number">' +
        '<a href="' + escapeHtml(buildContentPageUrl(page)) + '" class="pagination__link">' + page + "</a>" +
        "</li>"
      );
    }

    var pages = [];
    for (var p = 1; p <= totalPages; p++) {
      if (p === 1 || p === totalPages || Math.abs(p - currentPage) <= 1) {
        pages.push(p);
      } else if (pages[pages.length - 1] !== "...") {
        pages.push("...");
      }
    }

    var prevHtml = currentPage > 1
      ? '<li class="pagination__item pagination__item--prev"><a href="' +
        escapeHtml(buildContentPageUrl(currentPage - 1)) +
        '" class="pagination__link pagination__link--icon" aria-label="Previous"></a></li>'
      : '<li class="pagination__item pagination__item--prev"><a class="pagination__link pagination__link--icon is-disable" aria-disabled="true"></a></li>';

    var nextHtml = currentPage < totalPages
      ? '<li class="pagination__item pagination__item--next"><a href="' +
        escapeHtml(buildContentPageUrl(currentPage + 1)) +
        '" class="pagination__link pagination__link--icon" aria-label="Next"></a></li>'
      : '<li class="pagination__item pagination__item--next"><a class="pagination__link pagination__link--icon is-disable" aria-disabled="true"></a></li>';

    return (
      '<div class="pagination-wrapper"><nav class="pagination" role="navigation" aria-label="Pagination">' +
      '<ul class="pagination__list">' +
      prevHtml +
      pages.map(buildPageItem).join("") +
      nextHtml +
      "</ul></nav></div>"
    );
  }

  function renderContentResults(data) {
    var $inner = $("[data-search-default-mode] .l-inner");
    var items = Array.isArray(data.article_list) ? data.article_list : [];

    $inner.find(".c-grid, .pagination-wrapper, .pagination, .template-search__empty-results, [data-content-loading]").remove();

    var $count = $inner.find(".p-search-products__count");
    if ($count.length) {
      $count.text("(" + Number(data.total_count || 0).toLocaleString("ja-JP") + "件)");
    }

    if (items.length === 0) {
      $inner.append(
        '<div class="template-search__empty-results center">' +
        "<p>コンテンツが見つかりませんでした。</p>" +
        "<p>条件を変更して再度お試しください。</p>" +
        "</div>"
      );
      return;
    }

    var listHtml = '<ul class="c-grid c-grid--col-4 product-grid" role="list">' +
      items.map(renderContentCard).join("") +
      "</ul>";
    $inner.append(listHtml);
    $inner.append(renderContentPagination(data));
  }

  function fetchContentResults() {
    var page = getContentPage();
    var $inner = $("[data-search-default-mode] .l-inner");

    $inner.find(".c-grid, .pagination-wrapper, .pagination, .template-search__empty-results").remove();
    $inner.append('<div data-content-loading style="padding:2rem;text-align:center;">読み込み中...</div>');

    return fetch(buildContentApiUrl(page), {
      method: "GET",
      headers: { Accept: "application/json" },
      credentials: "same-origin",
    })
      .then(function (response) {
        if (!response.ok) throw new Error("Content search failed: " + response.status);
        return response.json();
      })
      .then(function (data) {
        $inner.find("[data-content-loading]").remove();
        renderContentResults(data);
      })
      .catch(function (error) {
        $inner.find("[data-content-loading]").remove();
        $inner.append(
          '<div class="template-search__empty-results center">' +
          "<p>コンテンツの読み込みに失敗しました。</p>" +
          "</div>"
        );
        console.error("[ContentSearch]", error);
      });
  }

  function prepareSearchMode() {
    const mode = getSearchMode();
    if (mode === "combined") {
      $("[data-search-product-mode]").prop("hidden", false);
      $("[data-search-default-mode]").prop("hidden", false);
    } else if (mode === "article" || mode === "default") {
      $("[data-search-product-mode]").prop("hidden", true);
      $("[data-search-default-mode]").prop("hidden", false);
    } else {
      $("[data-search-product-mode]").prop("hidden", false);
      $("[data-search-default-mode]").prop("hidden", true);
    }
    $("[data-search-filter-summary]").prop("hidden", true);
    return mode;
  }

  function getSearchQuery() {
    const params = getUrlParams();
    const inputValue = ($(".p-search-block__input").val() || "").trim();
    return inputValue || params.get("q") || params.get("key") || "";
  }

  function getCurrentInputValue() {
    return ($(".p-search-block__input").val() || "").trim();
  }

  function getCurrentPage() {
    const params = getUrlParams();
    const page = parseInt(params.get("current_page") || params.get("page"), 10);
    return Number.isFinite(page) && page > 0 ? page : 1;
  }

  function normalizeSortOrder(value) {
    const normalizedValue = String(value || "").trim().toLowerCase();

    return ALLOWED_SORT_ORDERS.indexOf(normalizedValue) !== -1 ? normalizedValue : "";
  }

  function sanitizeSortOrder(sortOrder, categories) {
    if (sortOrder === "popular" && (!Array.isArray(categories) || categories.length === 0)) {
      return "";
    }

    return sortOrder;
  }

  function getQueryCategories() {
    return (getUrlParams().get("category") || "")
      .split(",")
      .map(function (value) {
        return value.trim();
      })
      .filter(Boolean);
  }

  function getCollectionNameLabel() {
    const queryCategories = getQueryCategories();
    const collectionName = (getUrlParams().get("collection_name") || "").trim();
    if (collectionName && queryCategories.length === 1) {
      return collectionName;
    }
    return "";
  }

  function getSortOrder() {
    const sortOrder = normalizeSortOrder(getUrlParams().get("sort") || getUrlParams().get("sort_order"));
    return sanitizeSortOrder(sortOrder, getQueryCategories());
  }

  function getPriceFilters() {
    const maxValue =
      parseInt($('.c-modal__filter-range[data-range="max"]').val(), 10) || currentRangeMax;

    return {
      min: parseInt($('.c-modal__filter-range[data-range="min"]').val(), 10) || RANGE_MIN,
      max: Math.min(maxValue, currentRangeMax),
    };
  }

  function getDefaultPriceFilters() {
    return {
      min: RANGE_MIN,
      max: currentRangeMax,
    };
  }

  function isPriceInSliderRange(value) {
    return Number.isFinite(value) && value >= RANGE_MIN && value <= currentRangeMax;
  }

  function getQueryPriceFilters() {
    const params = getUrlParams();
    return {
      min: parseInt(params.get("price_min"), 10),
      max: parseInt(params.get("price_max"), 10),
    };
  }

  function getRequestPriceFilters() {
    const sliderFilters = getPriceFilters();
    const defaultFilters = getDefaultPriceFilters();
    const queryFilters = getQueryPriceFilters();

    if (hasUserAdjustedPriceRange) {
      return sliderFilters;
    }

    return {
      min:
        Number.isFinite(queryFilters.min)
            ? queryFilters.min
            : sliderFilters.min !== defaultFilters.min
              ? sliderFilters.min
              : defaultFilters.min,
      max:
        Number.isFinite(queryFilters.max)
          ? queryFilters.max
          : sliderFilters.max !== defaultFilters.max
            ? sliderFilters.max
            : defaultFilters.max,
    };
  }

  function hasOpenEndedMax(filters) {
    return filters.max >= currentRangeMax;
  }

  function getRequestPriceMax(filters) {
    const queryFilters = getQueryPriceFilters();

    if (!hasUserAdjustedPriceRange && Number.isFinite(queryFilters.max)) {
      return queryFilters.max;
    }

    return hasOpenEndedMax(filters) ? null : filters.max;
  }

  function getSelectedCategories() {
    const selectedCategories = [];

    $(".c-modal__filter-tags .c-tag--active").each(function () {
      selectedCategories.push(String($(this).data("value")));
    });

    return selectedCategories;
  }

  function getToggleStates() {
    return {
      free_shipping: $('input[name="free-shipping"]').is(":checked"),
      in_store: $('input[name="in-store"]').is(":checked"),
      include_out_of_stock: $('input[name="include-out-of-stock"]').is(":checked"),
    };
  }

  function syncCheckboxGroup(name, checked, source) {
    $('input[name="' + name + '"]').each(function () {
      if (source && this === source) {
        return;
      }

      $(this).prop("checked", checked);
    });
  }

  function initSyncedFilterToggles() {
    $(document).on("change", '.c-modal__filter-toggle-input[name]', function () {
      syncCheckboxGroup($(this).attr("name"), $(this).is(":checked"), this);
    });
  }

  function getDefaultToggleStates() {
    return {
      free_shipping: false,
      in_store: false,
      include_out_of_stock: true,
    };
  }

  function syncRangeBounds() {
    const $minSlider = $('.c-modal__filter-range[data-range="min"]');
    const $maxSlider = $('.c-modal__filter-range[data-range="max"]');
    const params = getUrlParams();
    const requestedMin = parseInt(params.get("price_min"), 10);
    const requestedMax = parseInt(params.get("price_max"), 10);

    currentRangeMax = RANGE_MAX;
    $minSlider.attr("max", currentRangeMax);
    $maxSlider.attr("max", currentRangeMax);

    if (!Number.isFinite(requestedMin)) {
      $minSlider.val(RANGE_MIN);
    }

    if (!Number.isFinite(requestedMax)) {
      $maxSlider.val(currentRangeMax);
    }
  }

  function syncFiltersFromQuery() {
    const params = getUrlParams();
    const min = parseInt(params.get("price_min"), 10);
    const max = parseInt(params.get("price_max"), 10);
    const defaultFilters = getDefaultPriceFilters();
    const minForSlider = isPriceInSliderRange(min) ? min : defaultFilters.min;
    const maxForSlider = isPriceInSliderRange(max) ? max : defaultFilters.max;
    const categories = getQueryCategories();
    const includeOutOfStockParam = params.get("include_out_of_stock") || params.get("include-out-of-stock");
    const includeOutOfStock =
      includeOutOfStockParam == null
        ? true
        : includeOutOfStockParam === "true" || includeOutOfStockParam === "on";
    const freeShipping =
      params.get("free_shipping") === "true" || params.get("free-shipping") === "on";
    const inStore = params.get("in_store") === "true" || params.get("in-store") === "on";

    $('.c-modal__filter-range[data-range="min"]').val(minForSlider);
    $('.c-modal__filter-range[data-range="max"]').val(maxForSlider);

    $(".c-modal__filter-tags .c-tag").each(function () {
      $(this).toggleClass(
        "c-tag--active",
        categories.indexOf(String($(this).data("value"))) !== -1
      );
    });

    $('input[name="include-out-of-stock"]').prop("checked", includeOutOfStock);
    $('input[name="free-shipping"]').prop("checked", freeShipping);
    $('input[name="in-store"]').prop("checked", inStore);
    $(".p-search-block__input").val(params.get("q") || params.get("key") || $(".p-search-block__input").val());
  }

  function updatePriceRange() {
    const filters = getPriceFilters();
    const queryFilters = getQueryPriceFilters();
    const minPercent = currentRangeMax ? (filters.min / currentRangeMax) * 100 : 0;
    const maxPercent = currentRangeMax ? (filters.max / currentRangeMax) * 100 : 100;
    const trackElement = document.querySelector(".c-modal__filter-range-track");
    const priceValuesElement = document.querySelector(".c-modal__filter-price-values");
    const minLabelElement = document.querySelector(".c-modal__filter-price-min");
    const isOpenEndedMax = hasOpenEndedMax(filters);
    const shouldHideMinLabel =
      !hasUserAdjustedPriceRange &&
      Number.isFinite(queryFilters.min) &&
      !isPriceInSliderRange(queryFilters.min);

    $(".c-modal__filter-price-min").text(formatPrice(filters.min) + "\u301c");
    $(".c-modal__filter-price-max").text(
      isOpenEndedMax ? formatPrice(currentRangeMax) + "\u301c" : "\u301c" + formatPrice(filters.max)
    );

    if (minLabelElement) {
      minLabelElement.hidden = shouldHideMinLabel;
    }

    if (trackElement) {
      trackElement.style.setProperty("--range-min", minPercent + "%");
      trackElement.style.setProperty("--range-max", 100 - maxPercent + "%");
    }

    if (priceValuesElement) {
      priceValuesElement.style.setProperty("--range-min", minPercent + "%");
      priceValuesElement.style.setProperty("--range-max", 100 - maxPercent + "%");
    }

    updatePriceValueLayout(minPercent, maxPercent);
  }

  function updatePriceValueLayout(minPercent, maxPercent) {
    const minLabel = document.querySelector(".c-modal__filter-price-min");
    const maxLabel = document.querySelector(".c-modal__filter-price-max");
    const sliderElement = document.querySelector(".c-modal__filter-price-slider");
    const thumbOffset = 16;
    const gap = 0;

    if (!minLabel || !maxLabel || !sliderElement) {
      return;
    }

    const sliderWidth = sliderElement.clientWidth;

    if (!sliderWidth) {
      return;
    }

    const usableWidth = sliderWidth - thumbOffset * 2;
    const minHalfWidth = minLabel.hidden ? 0 : minLabel.offsetWidth / 2;
    const maxHalfWidth = maxLabel.offsetWidth / 2;
    const minRawLeft = thumbOffset + (usableWidth * minPercent) / 100;
    const maxRawLeft = thumbOffset + (usableWidth * maxPercent) / 100;
    const maxLeft = Math.min(Math.max(maxRawLeft, maxHalfWidth), sliderWidth - maxHalfWidth);
    const minStopLeft = Math.max(minHalfWidth, maxLeft - maxHalfWidth - minHalfWidth - gap);
    const minLeft = Math.min(Math.max(minRawLeft, minHalfWidth), minStopLeft);

    if (!minLabel.hidden) {
      minLabel.style.left = minLeft + "px";
    }
    maxLabel.style.left = maxLeft + "px";
  }

  function schedulePriceRangeLayoutUpdate() {
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        updatePriceRange();
      });
    });
  }

  function updateFilterSummary(filters, categories, toggleStates) {
    const $summary = $("[data-search-filter-summary]");
    const $tags = $("[data-search-filter-tags]");
    const defaultFilters = getDefaultPriceFilters();
    const isDefaultRange = filters.min === defaultFilters.min && filters.max === defaultFilters.max;

    if (!$summary.length || !$tags.length) {
      return;
    }

    $tags.empty();

    if (!isDefaultRange) {
      $tags.append(
        $("<span />", {
          class: "c-tag",
          text: hasOpenEndedMax(filters)
            ? formatPrice(filters.min) + "\u301c"
            : formatPrice(filters.min) + "\u301c" + formatPrice(filters.max),
        })
      );
    }

    categories.forEach(function (category) {
      const $categoryTag = $(".c-modal__filter-tags .c-tag[data-value=\"" + category + "\"]").first();
      $tags.append(
        $("<span />", {
          class: "c-tag",
          text: $categoryTag.text().trim() || category,
        })
      );
    });

    const defaultToggleStates = getDefaultToggleStates();

    Object.keys(toggleStates).forEach(function (key) {
      if (toggleStates[key] !== true) {
        return;
      }

      if (defaultToggleStates[key] === true) {
        return;
      }

      const selectorMap = {
        free_shipping: 'input[name="free-shipping"]',
        in_store: 'input[name="in-store"]',
        include_out_of_stock: 'input[name="include-out-of-stock"]',
      };
      const $toggle = $(selectorMap[key]).first();
      const labelText = $toggle
        .closest(".c-modal__filter-toggle-label")
        .find(".c-modal__filter-toggle-text")
        .first()
        .text()
        .trim();

      if (labelText) {
        $tags.append($("<span />", { class: "c-tag", text: labelText }));
      }
    });

    $summary.prop("hidden", $tags.children().length === 0);
  }

  function hasActiveFilters(filters, categories, toggleStates) {
    const defaultFilters = getDefaultPriceFilters();
    const defaultToggleStates = getDefaultToggleStates();
    return (
      categories.length > 0 ||
      filters.min !== defaultFilters.min ||
      filters.max !== defaultFilters.max ||
      toggleStates.free_shipping !== defaultToggleStates.free_shipping ||
      toggleStates.in_store !== defaultToggleStates.in_store ||
      toggleStates.include_out_of_stock !== defaultToggleStates.include_out_of_stock
    );
  }

  function buildSearchUrl(overrides) {
    const url = new URL("/search", window.location.origin);
    const filters = getRequestPriceFilters();
    const selectedCategories = getSelectedCategories();
    const toggleStates = getToggleStates();
    const params = overrides || {};
    const searchQuery = Object.prototype.hasOwnProperty.call(params, "q")
      ? params.q
      : getCurrentInputValue();
    const currentPage =
      Object.prototype.hasOwnProperty.call(params, "current_page") ? params.current_page : 1;
    const sortOrder = sanitizeSortOrder(
      normalizeSortOrder(
        Object.prototype.hasOwnProperty.call(params, "sort")
          ? params.sort
          : Object.prototype.hasOwnProperty.call(params, "sort_order")
            ? params.sort_order
            : getSortOrder()
      ),
      selectedCategories
    );

    if (searchQuery) {
      url.searchParams.set("q", searchQuery);
    }

    if (filters.min !== getDefaultPriceFilters().min) {
      url.searchParams.set("price_min", String(filters.min));
    }

    const requestPriceMax = getRequestPriceMax(filters);
    if (requestPriceMax !== null) {
      url.searchParams.set("price_max", String(requestPriceMax));
    }

    if (selectedCategories.length) {
      url.searchParams.set("category", selectedCategories.join(","));
    }

    if (toggleStates.free_shipping) {
      url.searchParams.set("free_shipping", "true");
    }

    if (toggleStates.in_store) {
      url.searchParams.set("in_store", "true");
    }

    url.searchParams.set(
      "include_out_of_stock",
      toggleStates.include_out_of_stock ? "true" : "false"
    );

    if (currentPage > 1) {
      url.searchParams.set("current_page", String(currentPage));
    }

    if (sortOrder) {
      url.searchParams.set("sort", sortOrder);
    }

    if (isArticleOriginMode()) {
      url.searchParams.set("type", getUrlParams().get("type") || "article");
      url.searchParams.set("section", "product");
    }

    return url.toString();
  }

  function buildClearedSearchUrl() {
    const url = new URL("/search", window.location.origin);
    const searchQuery = getCurrentInputValue();

    if (searchQuery) {
      url.searchParams.set("q", searchQuery);
    }

    return url.toString();
  }

  function buildApiUrl() {
    const url = new URL(API_PATH, window.location.origin);
    const filters = getRequestPriceFilters();
    const selectedCategories = getSelectedCategories();
    const toggleStates = getToggleStates();
    const searchQuery = getSearchQuery();
    const currentPage = getCurrentPage();
    const sortOrder = sanitizeSortOrder(getSortOrder(), selectedCategories);

    if (searchQuery) {
      url.searchParams.set("key", searchQuery);
    }

    if (selectedCategories.length) {
      url.searchParams.set("category", selectedCategories.join(","));
    }

    if (filters.min !== getDefaultPriceFilters().min) {
      url.searchParams.set("price_min", String(filters.min));
    }

    const requestPriceMax = getRequestPriceMax(filters);
    if (requestPriceMax !== null) {
      url.searchParams.set("price_max", String(requestPriceMax));
    }

    url.searchParams.set(
      "include_out_of_stock",
      toggleStates.include_out_of_stock ? "true" : "false"
    );

    if (toggleStates.free_shipping) {
      url.searchParams.set("free_shipping", "true");
    }

    if (toggleStates.in_store) {
      url.searchParams.set("in_store", "true");
    }

    url.searchParams.set("page_size", String(PAGE_SIZE));
    url.searchParams.set("current_page", String(currentPage));

    if (sortOrder) {
      url.searchParams.set("sort", sortOrder);
    }

    return url.toString();
  }

  function ensureStatusNode() {
    let $status = $("[data-search-loading]");

    if (!$status.length) {
      $status = $('<div class="template-search__status center" data-search-loading hidden></div>');
      $("[data-search-results-list]").before($status);
    }

    return $status.first();
  }

  function setLoadingState(isLoading, message) {
    const $status = ensureStatusNode();
    $status.text(message || "Loading...");
    $status.prop("hidden", !isLoading);
  }

  function getNestedValue(source, path) {
    return path.split(".").reduce(function (current, key) {
      if (current == null) {
        return undefined;
      }

      return current[key];
    }, source);
  }

  function unwrapMetaValue(value) {
    if (value && typeof value === "object" && Object.prototype.hasOwnProperty.call(value, "value")) {
      return value.value;
    }

    return value;
  }

  function getFirstDefinedValue(source, paths) {
    for (let index = 0; index < paths.length; index += 1) {
      const value = unwrapMetaValue(getNestedValue(source, paths[index]));

      if (value !== undefined && value !== null && value !== "") {
        return value;
      }
    }

    return "";
  }

  function normalizeProductTags(product) {
    const rawTags = getFirstDefinedValue(product, ["tags"]);

    if (Array.isArray(rawTags)) {
      return rawTags.map(function (tag) {
        return String(tag || "").trim();
      }).filter(Boolean);
    }

    if (typeof rawTags === "string") {
      return rawTags.split(",").map(function (tag) {
        return tag.trim();
      }).filter(Boolean);
    }

    return [];
  }

  function hasProductTag(tags, tagName) {
    return tags.some(function (tag) {
      return tag.toLowerCase() === String(tagName || "").toLowerCase();
    });
  }

  function getBooleanMeta(product, paths) {
    const value = getFirstDefinedValue(product, paths);

    if (typeof value === "boolean") {
      return value;
    }

    if (typeof value === "string") {
      return value === "true";
    }

    return Boolean(value);
  }

  function resolveButtonType(product) {
    const status = String(getFirstDefinedValue(product, ["status"]) || "")
      .trim()
      .toLowerCase();

    return status || (Boolean(product.available) ? "available" : "out_of_stock");
  }

  function isPreorderSale(product) {
    return getFirstDefinedValue(product, ["sales_method"]) === "予約販売";
  }

  function getEndedButtonLabel(product) {
    if (getBooleanMeta(product, ["ec_exclusive", "metafields.yokumoku.ec_exclusive"])) {
      return "オンライン販売終了しました";
    }

    return "販売終了しました";
  }

  function renderProductTags(product, tags, buttonType) {
    const configuredTags = Array.isArray(window.searchAvailableItemTags)
      ? window.searchAvailableItemTags
      : [];
    const tagHtml = [];

    configuredTags.forEach(function (configuredTag) {
      if (configuredTag === "一部店舗限定") return;
      if (hasProductTag(tags, configuredTag)) {
        tagHtml.push('<span class="c-tag">' + escapeHtml(configuredTag) + "</span>");
      }
    });

    if (getBooleanMeta(product, ["flags_wrapping"])) {
      tagHtml.push('<span class="c-tag">ラッピング対応</span>');
    }

    if (getBooleanMeta(product, ["flags_noshi"])) {
      tagHtml.push('<span class="c-tag">のし対応</span>');
    }

    if (getBooleanMeta(product, ["flags_is_social_gift_available"])) {
      tagHtml.push('<span class="c-tag">eギフト対応</span>');
    }

    if (getBooleanMeta(product, ["ec_exclusive"])) {
      tagHtml.push('<span class="c-tag">オンライン限定</span>');
    }

    if (getFirstDefinedValue(product, ["temperature_zone"]) === "冷凍") {
      tagHtml.push('<span class="c-tag">冷凍</span>');
    }

    if (buttonType === "store_only") {
      if (hasProductTag(tags, "一部店舗限定")) {
        tagHtml.push('<span class="c-tag">一部店舗限定</span>');
      } else {
        tagHtml.push('<span class="c-tag">店舗のみ</span>');
      }
    }

    if (buttonType === "partial_online") {
      tagHtml.push('<span class="c-tag">一部オンライン限定</span>');
    }

    if (!tagHtml.length) {
      return "";
    }

    return '<div class="c-tags">' + tagHtml.join("") + "</div>";
  }

  function renderProductButton(product, buttonType, url) {
    const variantId = getFirstDefinedValue(product, ["variant_id"]);
    const productId = getFirstDefinedValue(product, ["product_id", "id"]);
    const oosMessage = escapeHtml(getFirstDefinedValue(product, ["oos_message"]) || "");

    if (buttonType === "available") {
      const addToCartLabel = isPreorderSale(product)
        ? "予約商品をカートに入れる"
        : getSearchTranslation("add_to_cart", "カートに入れる");
      var setitemsAttr = "";
      var setitems = product.setitems;
      if (setitems && Array.isArray(setitems) && setitems.length > 0) {
        // 新形式 {id, quantity} オブジェクト配列 or 旧形式 GID文字列配列に対応
        var setitemsCsv = setitems.map(function (item) {
          if (typeof item === 'object' && item !== null && item.id != null) {
            var m = String(item.id).match(/(\d+)$/);
            var numId = m ? m[1] : String(item.id);
            var qty = item.quantity || 1;
            return numId + ':' + qty;
          }
          var m = String(item).match(/(\d+)$/);
          return m ? m[1] + ':1' : String(item) + ':1';
        }).join(",");
        setitemsAttr = ' data-setitems="' + escapeHtml(setitemsCsv) + '" data-product-title="' + escapeHtml(product.title) + '"';
      }
      return (
        '<a href="#" class="c-btn__cart js-add-to-cart" data-product-id="' +
        escapeHtml(variantId) +
        '" data-product-url="' +
        url +
        '"' +
        setitemsAttr +
        '>' +
        escapeHtml(addToCartLabel) +
        "</a>"
      );
    }

    if (buttonType === "sale_not_started") {
      var saleNotStartedLabel = isPreorderSale(product)
        ? "予約販売開始前"
        : getSearchTranslation("sale_not_started", "販売開始前");
      return (
        '<a href="' +
        url +
        '" class="c-btn__cart c-btn__cart--period">' +
        escapeHtml(saleNotStartedLabel) +
        "</a>"
      );
    }

    if (buttonType === "sale_ended") {
      return (
        '<a href="' +
        url +
        '" class="c-btn__cart c-btn__cart--period">' +
        escapeHtml(getEndedButtonLabel(product)) +
        "</a>"
      );
    }

    if (buttonType === "restock") {
      return (
        '<a href="' +
        url +
        '" class="c-btn__cart c-btn__cart--restock">' +
        escapeHtml(getSearchTranslation("restock", "再入荷お知らせ")) +
        "</a>"
      );
    }

    if (buttonType === "store_only") {
      return (
        '<a href="' +
        url +
        '" class="c-btn__cart c-btn__cart--store">' +
        escapeHtml(getSearchTranslation("store_only", "店舗限定")) +
        "</a>"
      );
    }

    if (buttonType === "partial_online") {
      return (
        '<a href="' +
        url +
        '" class="c-btn__cart c-btn__cart--period">' +
        escapeHtml(getSearchTranslation("partial_online", "一部オンライン限定")) +
        "</a>"
      );
    }

    if (buttonType === "out_of_stock") {
      return (
        '<a href="' + url + '" class="c-btn__cart c-btn__cart--out-stock">' +
        (oosMessage || escapeHtml(getSearchTranslation("out_of_stock", "ただいま品切れしております"))) +
        "</a>"
      );
    }

    if (buttonType === "unavailable") {
      return (
        '<a href="' + url + '" class="c-btn__cart c-btn__cart--out-stock">' +
        (oosMessage || escapeHtml(getEndedButtonLabel(product))) +
        "</a>"
      );
    }

    return (
      '<a href="' + url + '" class="c-btn__cart c-btn__cart--out-stock">' +
      (oosMessage || escapeHtml(getEndedButtonLabel(product))) +
      "</a>"
    );
  }

  function renderProductCard(product) {
    const title = escapeHtml(product.title);
    const url = escapeHtml(product.url || (product.handle ? "/products/" + product.handle : "#"));
    const image = product.image ? escapeHtml(product.image) : "";
    const imageAlt = title;
    const price = formatPrice(product.price);
    const priceYen = product.price != null ? Math.round(Number(product.price)) : null;
    const rawId = getFirstDefinedValue(product, ["product_id", "id"]);
    const idMatch = rawId != null ? String(rawId).match(/(\d+)$/) : null;
    const numericProductId = idMatch ? idMatch[1] : "";
    const discountAttrs = (priceYen != null && priceYen > 0 && numericProductId)
      ? ' data-discount-price="' + priceYen + '" data-product-id="' + escapeHtml(numericProductId) + '"'
      : "";
    const tags = normalizeProductTags(product);
    const salesStartAt = getFirstDefinedValue(product, ["sales_start_datetime"]);
    let showNewBadge = false;
    if (salesStartAt) {
      const startMs = new Date(salesStartAt).getTime();
      const nowMs = Date.now();
      if (!isNaN(startMs) && nowMs >= startMs && nowMs - startMs <= 30 * 24 * 60 * 60 * 1000) {
        showNewBadge = true;
      }
    }
    const customerType = window.yokumokuCustomerType || "通販顧客";
    const nationwideTag = "全国送料無料_" + customerType;
    const showNationwideBadge = hasProductTag(tags, nationwideTag);
    const showFreeBadge = !showNationwideBadge && hasProductTag(tags, "送料無料");
    const buttonType = resolveButtonType(product);
    const badgeHtml = [];

    if (showNewBadge) {
      badgeHtml.push('<span class="c-product-card__label c-product-card__label--new">NEW</span>');
    }

    if (showNationwideBadge) {
      badgeHtml.push('<span class="c-product-card__label c-product-card__label--free-shipping">全国送料無料</span>');
    } else if (showFreeBadge) {
      badgeHtml.push('<span class="c-product-card__label c-product-card__label--free-shipping">オンライン送料無料</span>');
    }

    return (
      '<li class="c-grid__item" data-search-result-item data-search-type="product">' +
      '<article>' +
      '<div class="c-product-card">' +
      '<a href="' + url + '" class="c-product-card__img">' +
      (image
        ? '<img src="' + image + '" alt="' + imageAlt + '" loading="lazy">'
        : '<div class="c-product-card__img-placeholder"></div>') +
      "</a>" +
      (badgeHtml.length
        ? '<div class="c-product-card__badge">' + badgeHtml.join("") + "</div>"
        : "") +
      '<div class="c-product-card__body">' +
      '<div class="js-matchHeight-item">' +
      '<a href="' + url + '" class="c-product-card__title">' + title + "</a>" +
      renderProductTags(product, tags, buttonType) +
      '<p class="c-product-card__price"' + discountAttrs + '>' +
      price +
      "<small>(税込)</small>" +
      "</p>" +
      "</div>" +
      renderProductButton(product, buttonType, url) +
      "</div>" +
      "</div>" +
      "</article>" +
      "</li>"
    );
  }

  function updateResultsTitle(totalCount) {
    const $title = $("[data-search-results-title]").first();
    const $count = $("[data-search-results-count]").first();
    const searchQuery = getSearchQuery();
    const filters = getPriceFilters();
    const selectedCategories = getSelectedCategories();
    const toggleStates = getToggleStates();
    const activeFilters = hasActiveFilters(filters, selectedCategories, toggleStates);
    let nextTitle = $title.data("default-title");

    if (getSearchMode() === "combined") {
      nextTitle = "商品の検索結果" + (searchQuery ? "「" + searchQuery + "」" : "");
    } else if (searchQuery) {
      nextTitle = searchQuery;
    } else if (getCollectionNameLabel()) {
      nextTitle = getCollectionNameLabel();
    } else if (activeFilters) {
      nextTitle = $title.data("filtered-title");
    }

    if (totalCount === 0 && getSearchMode() !== "combined") {
      nextTitle = $title.data("empty-title");
    }

    if ($count.length) {
      $count.text("(" + Number(totalCount || 0).toLocaleString("ja-JP") + "\u5546\u54c1)");
    }

    if ($title.length) {
      const textNode = $title
        .contents()
        .filter(function () {
          return this.nodeType === Node.TEXT_NODE;
        })
        .first();

      if (textNode.length) {
        textNode[0].nodeValue = nextTitle + " ";
      } else {
        $title.prepend(document.createTextNode(nextTitle + " "));
      }
    }
  }

  function renderPagination(data) {
    $("[data-search-product-mode] .pagination-wrapper").remove();
    $("[data-search-product-mode] .pagination").remove();

    const totalPages = parseInt(data.total_page, 10) || 0;
    const currentPage = parseInt(data.current_page, 10) || 1;

    if (totalPages <= 1) {
      return;
    }

    function buildPageItem(page) {
      if (page === "...") {
        return '<li class="pagination__item pagination__item--dots"><span class="pagination__link">...</span></li>';
      }

      if (page === currentPage) {
        return (
          '<li class="pagination__item pagination__item--number"><a class="pagination__link is-active">' +
          page +
          "</a></li>"
        );
      }

      return (
        '<li class="pagination__item pagination__item--number"><a href="' +
        escapeHtml(buildSearchUrl({ current_page: page })) +
        '" class="pagination__link">' +
        page +
        "</a></li>"
      );
    }

    const pages = [];
    for (let page = 1; page <= totalPages; page += 1) {
      if (
        page === 1 ||
        page === totalPages ||
        Math.abs(page - currentPage) <= 1
      ) {
        pages.push(page);
      } else if (pages[pages.length - 1] !== "...") {
        pages.push("...");
      }
    }

    const prevHtml =
      currentPage > 1
        ? '<li class="pagination__item pagination__item--prev"><a href="' +
          escapeHtml(buildSearchUrl({ current_page: currentPage - 1 })) +
          '" class="pagination__link pagination__link--icon" aria-label="Previous"></a></li>'
        : '<li class="pagination__item pagination__item--prev"><a class="pagination__link pagination__link--icon is-disable" aria-disabled="true"></a></li>';
    const nextHtml =
      currentPage < totalPages
        ? '<li class="pagination__item pagination__item--next"><a href="' +
          escapeHtml(buildSearchUrl({ current_page: currentPage + 1 })) +
          '" class="pagination__link pagination__link--icon" aria-label="Next"></a></li>'
        : '<li class="pagination__item pagination__item--next"><a class="pagination__link pagination__link--icon is-disable" aria-disabled="true"></a></li>';

    const html =
      '<div class="pagination-wrapper"><nav class="pagination" role="navigation" aria-label="Pagination"><ul class="pagination__list">' +
      prevHtml +
      pages.map(buildPageItem).join("") +
      nextHtml +
      "</ul></nav></div>";

    $("[data-search-results-list]").after(html);
  }

  function renderResults(data) {
    const products = Array.isArray(data.product_list) ? data.product_list : [];
    const $list = $("[data-search-results-list]").first();
    const $emptyState = $("[data-search-empty-state]").first();

    $list.empty();

    if (products.length) {
      $list.html(
        products
          .map(function (product) {
            return renderProductCard(product);
          })
          .join("")
      );
      if (window.DiscountPrice) window.DiscountPrice.apply($list[0]);
      $emptyState.prop("hidden", true);
    } else {
      $emptyState.prop("hidden", false);
    }

    updateResultsTitle(data.total_product || 0);
    renderPagination(data);
  }

  function fetchSearchResults() {
    const filters = getPriceFilters();
    const selectedCategories = getSelectedCategories();
    const toggleStates = getToggleStates();

    updateFilterSummary(filters, selectedCategories, toggleStates);
    setLoadingState(true, "Loading...");

    return fetch(buildApiUrl(), {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
      credentials: "same-origin",
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error("Search request failed: " + response.status);
        }

        return response.json();
      })
      .then(function (data) {
        renderResults(data);
        setLoadingState(false);
      })
      .catch(function (error) {
        $("[data-search-results-list]").first().empty();
        $("[data-search-empty-state]").first().prop("hidden", false);
        updateResultsTitle(0);
        renderPagination({ total_page: 0, current_page: 1 });
        setLoadingState(true, "Search error");
        console.error(error);
      });
  }

  function applySearchState(overrides) {
    const nextUrl = buildSearchUrl(overrides);
    window.history.pushState({}, "", nextUrl);
    return fetchSearchResults();
  }

  function initFilterModal() {
    $(".c-modal__filter-tags .c-tag").on("click", function () {
      $(this).toggleClass("c-tag--active");
    });

    $(".c-modal__filter-clear").on("click", function () {
      hasUserAdjustedPriceRange = true;
      $(".c-modal__filter-tags .c-tag").removeClass("c-tag--active");
      $(".c-modal__filter-toggle-input").prop("checked", false);
      $('input[name="include-out-of-stock"]').prop("checked", true);
      const defaultFilters = getDefaultPriceFilters();
      $('.c-modal__filter-range[data-range="min"]').val(defaultFilters.min);
      $('.c-modal__filter-range[data-range="max"]').val(defaultFilters.max);
      updatePriceRange();
      updateFilterSummary(defaultFilters, [], getToggleStates());
    });

    $("#filter-form").on("submit", function (event) {
      event.preventDefault();
      window.location.href = buildSearchUrl({ current_page: 1 });
    });

    $(".c-modal__filter-submit").on("click", function (event) {
      event.preventDefault();
      $("#filter-form").trigger("submit");
    });

    $('.js-modal-open[data-modal="modal-filter"]').on("click", function () {
      schedulePriceRangeLayoutUpdate();
    });

    $(window).on("resize", function () {
      if ($("#modal-filter").hasClass("is-active")) {
        schedulePriceRangeLayoutUpdate();
      }
    });
  }

  function initPriceRangeSlider() {
    const minSlider = $('.c-modal__filter-range[data-range="min"]');
    const maxSlider = $('.c-modal__filter-range[data-range="max"]');

    if (!minSlider.length || !maxSlider.length) {
      return;
    }

    minSlider.on("input", function () {
      hasUserAdjustedPriceRange = true;
      const minVal = parseInt($(this).val(), 10);
      const maxVal = parseInt(maxSlider.val(), 10);

      if (minVal > maxVal - RANGE_GAP) {
        $(this).val(maxVal - RANGE_GAP);
      }

      updatePriceRange();
    });

    maxSlider.on("input", function () {
      hasUserAdjustedPriceRange = true;
      const minVal = parseInt(minSlider.val(), 10);
      const maxVal = parseInt($(this).val(), 10);

      if (maxVal < minVal + RANGE_GAP) {
        $(this).val(minVal + RANGE_GAP);
      }

      updatePriceRange();
    });

    updatePriceRange();
  }

  function initSearchInput() {
    $(".p-search-block__form").on("submit", function (event) {
      event.preventDefault();
      window.location.href = buildSearchUrl({ q: getCurrentInputValue(), current_page: 1 });
    });
  }

  function initInlineOutOfStockToggle() {
    $(document).on(
      "change",
      ".p-search-block__inline-toggle input[name=\"include-out-of-stock\"]",
      function () {
        applySearchState({ current_page: 1 });
      }
    );
  }

  function customDropdown() {
    $(".js-dropdown").each(function () {
      const $dropdown = $(this);
      const $toggle = $dropdown.find(".p-search-products__toggle");
      const $options = $dropdown.find(".p-search-products__options");
      const defaultLabel = $toggle.text().trim();
      const selectedCategories = getSelectedCategories();
      const currentSortOrder = sanitizeSortOrder(getSortOrder(), selectedCategories);
      const selectedValue = currentSortOrder || "";

      let selectedLabel = defaultLabel;

      $options.find("li").each(function () {
        const $option = $(this);
        const optionValue = normalizeSortOrder($option.data("value"));
        const isDefaultOption = $option.data("default-sort") === true;
        const requiresCategory = $option.data("requires-category") === true;
        const isDisabled = requiresCategory && selectedCategories.length === 0;
        const isHidden = isDisabled;
        const isSelected = isDefaultOption ? selectedValue === "" : optionValue === selectedValue;
        const disabledTooltip = isDisabled ? "人気順はカテゴリ選択時のみ利用できます" : "";

        $option.toggleClass("is-selected", isSelected);
        $option.toggleClass("is-disabled", isDisabled);
        $option.prop("hidden", isHidden);
        $option.attr("aria-hidden", isHidden ? "true" : "false");
        $option.attr("aria-disabled", isDisabled ? "true" : "false");
        $option.attr("title", disabledTooltip);
        $option.attr("aria-label", disabledTooltip || $option.text().trim());

        if (isSelected && !isDefaultOption) {
          selectedLabel = $option.text().trim();
        }
      });

      $toggle.text(selectedLabel).toggleClass("is-selected", selectedLabel !== defaultLabel);

      $toggle.on("click", function () {
        $dropdown.toggleClass("is-open");
        $options.toggleClass("show");
      });

      $options.on("click", "li", function () {
        if ($(this).hasClass("is-disabled")) {
          return;
        }

        const selectedSortOrder = normalizeSortOrder($(this).data("value"));
        const sortOrder = sanitizeSortOrder(selectedSortOrder, getSelectedCategories());
        window.location.href = buildSearchUrl({ current_page: 1, sort: sortOrder });
      });
    });
  }

  const searchMode = prepareSearchMode();

  initFilterModal();
  initSyncedFilterToggles();
  syncRangeBounds();
  syncFiltersFromQuery();
  initPriceRangeSlider();
  customDropdown();
  initInlineOutOfStockToggle();

  if (searchMode === "combined") {
    // Move search form into product section (after header/title)
    var $searchBlock = $(".p-search-block");
    $("[data-search-product-mode] .p-search-products__header").after($searchBlock);

    // Change article section title to "コンテンツの検索結果「{keyword}」"
    var $articleTitle = $("[data-search-default-mode] .p-search-products__title");
    var articleQuery = getSearchQuery();
    var articleTitleText = "コンテンツの検索結果" + (articleQuery ? "「" + articleQuery + "」" : "");
    $articleTitle.contents().filter(function () {
      return this.nodeType === Node.TEXT_NODE;
    }).each(function () {
      this.nodeValue = "";
    });
    $articleTitle.prepend(document.createTextNode(articleTitleText + " "));

    // Fetch content via API (sorted by date DESC)
    fetchContentResults();
    fetchSearchResults();
    return;
  }

  if (searchMode === "article" || searchMode === "default") {
    // Fetch content via API (sorted by date DESC)
    fetchContentResults();
    return;
  }

  initSearchInput();
  fetchSearchResults();
});
